import { createAsyncThunk } from '@reduxjs/toolkit';
import payrollServiceApiInstance from '../../../../../config/payrollApiConfig';

// Create
export const createExpense = createAsyncThunk(
  'expense/create',
  async (data: any, { rejectWithValue }) => {
    try {
      const formData = new FormData();

      Object.entries(data).forEach(([key, value]) => {
        if (typeof value === 'string' || value instanceof Blob) {
          formData.append(key, value);
        } else {
          formData.append(key, JSON.stringify(value));
        }
      });
      const res = await payrollServiceApiInstance.post('/expenses', formData, {
        headers: {
          'Content-Type': 'multipart/form-data' 
        },
      });

      return res.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || 'Failed to create expense');
    }
  }
);

// Get All
export const fetchAllExpenses = createAsyncThunk(
  'expense/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const res = await payrollServiceApiInstance.get('/expenses');
      return res.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || 'Failed to fetch expenses');
    }
  }
);

// Get By ID
export const fetchExpenseById = createAsyncThunk(
  'expense/fetchById',
  async (id: number, { rejectWithValue }) => {
    try {
      const res = await payrollServiceApiInstance.get(`/expenses/${id}`);
      return res.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || 'Failed to fetch expense');
    }
  }
);

// Update
export const updateExpense = createAsyncThunk(
  'expense/update',
  async (
    { id, data }: { id: number; data: any },
    { rejectWithValue }
  ) => {
    try {
      const formData = new FormData();

      Object.entries(data).forEach(([key, value]) => {
        if (typeof value === 'string' || value instanceof Blob) {
          formData.append(key, value);
        } else {
          formData.append(key, JSON.stringify(value));
        }
      });

      await payrollServiceApiInstance.put(`/expenses/${id}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data' 
        },
      });

      return { id, data };
    } catch (err: any) {
      return rejectWithValue(err.response?.data || 'Failed to update expense');
    }
  }
);

// Delete
export const deleteExpense = createAsyncThunk(
  'expense/delete',
  async (id: number, { rejectWithValue }) => {
    try {
      await payrollServiceApiInstance.delete(`/expenses/${id}`);
      return id;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || 'Failed to delete expense');
    }
  },
  
);
export const fetchExpensesByEmployeeId = createAsyncThunk(
  'expense/fetchByEmployeeId',
  async (employeeId: number, { rejectWithValue }) => {
    try {
      const res = await payrollServiceApiInstance.get(`/expenses/employee/${employeeId}`);
      return res.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || 'Failed to fetch expenses by employee ID');
    }
  }
);

export const fetchUniquePaymentMethods = createAsyncThunk(
  'expense/fetchUniquePaymentMethods',
  async (_, { rejectWithValue }) => {
    try {
      const res = await payrollServiceApiInstance.get('/expenses/list/payment-methods');
      return res.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || 'Failed to fetch payment methods');
    }
  }
);

export const fetchExpensesBySupervisorHierarchy = createAsyncThunk(
  "expenses/fetchExpensesBySupervisorHierarchy",
  async (
    { supervisorId, includeSelf = false }: { supervisorId: number; includeSelf?: boolean },
    { rejectWithValue }
  ) => {
    try {
      const response = await payrollServiceApiInstance.get(
        `/expenses/supervisor/${supervisorId}`,
        { params: { includeSelf } }
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch supervisor hierarchy expenses"
      );
    }
  }
);
